import Swiper from 'swiper/bundle';
import URLUtils from '../utils/URLUtils.js';
import Cache from '../utils/Cache.js';

export default class Panel {
  constructor(element) {
    this.element = element;
    this.options = {
      tabMode: false,
      theme: 'dark',
      navSlider: true,
      initialSlide: 0,
      initialButton: null,
    };
    this.bts = this.element.querySelectorAll('.js-nav-link');
    this.bar = this.element.querySelector('.js-nav-bar');

    this.init();
  }

  init() {
    this.setOptions();
    this.initNavSlider();

    this.swiper = new Swiper('.js-swiper-panel', {
      autoHeight: true,
      slidesPerView: 'auto',
      speed: 750,
      initialSlide: this.options.initialSlide,
      spaceBetween: 100,
      direction: 'vertical',
      allowTouchMove: false,
      breakpoints: {},
      on: {
        afterInit: (swiper) => {
          swiper.update();
          swiper.slideTo(this.options.initialSlide, 0);
          this.moveNavHover(this.getActiveButton(), true);
        },
      },
    });

    // Ugly matchmedia
    if (this.options.navSlider) {
      const mediaQuery = window.matchMedia('(min-width: 1440px)');
      mediaQuery.addEventListener('change', (event) => {
        this.moveNavHover(this.activeButton);
      });
    }
  }

  initNavSlider() {
    if (!this.options.navSlider) return false;

    // Check for an active button, else, sets the first button as active
    this.setActiveButton();

    for (let i = 0; i < this.bts.length; i++) {
      const bt = this.bts[i];

      if (bt.classList.contains('active')) {
        this.activeButton = bt;
        this.moveNavHover(this.activeButton);
      }

      bt.addEventListener('click', this.onClick.bind(this));
      bt.addEventListener('mouseenter', this.moveNavHover.bind(this));
      bt.addEventListener('mouseleave', this.moveNavLeave.bind(this));
    }
  }

  setOptions() {
    if ('tabMode' in this.element.dataset) {
      this.options.tabMode = true;
    }
    if ('noSlider' in this.element.dataset) {
      this.options.navSlider = false;
    }

    // Theme
    const btTheme = document.querySelector('.js-theme');
    if (btTheme) {
      btTheme.addEventListener('click', this.toggleTheme.bind(this));
    }

    const theme = Cache.get('gl_theme');
    if (theme) {
      document.documentElement.dataset.theme = theme;
    }

    // Backlink check
    const hash = URLUtils.parse().hash;
    if (hash && !isNaN(hash)) {
      this.options.initialSlide =
        [...this.bts].findIndex((el) => el.hash === `#${hash}`) || 0;
    }
  }

  toggleTheme() {
    const newTheme =
      document.documentElement.dataset.theme == 'dark' ? 'light' : 'dark';

    this.options.theme = newTheme;
    Cache.set('gl_theme', newTheme, true);
    document.documentElement.dataset.theme = newTheme;
  }

  setActiveButton() {
    const activeEl =
      Array.from(this.bts).filter((n) => n.classList.contains('active')) ||
      null;

    this.activeButton = activeEl.length ? activeEl : this.bts[0];
    if (this.activeButton) {
      this.activeButton.classList.add('active');
      this.bts[0].classList.remove('active');
    }
  }

  getActiveButton() {
    return this.bts[this.options.initialSlide] || this.bts[0];
  }

  onClick(e) {
    const target = e.currentTarget.parentElement;
    const index = Array.from(target.parentElement.children).indexOf(target);
    this.activeButton.classList.remove('active');
    this.activeButton = e.currentTarget;
    e.currentTarget.classList.add('active');

    this.swiper.slideTo(index);
  }

  moveNavLeave(e) {
    this.moveNavHover(this.activeButton);
  }

  moveNavHover(e, skipAnimation) {
    const target = e?.currentTarget || e;
    const x = target.offsetLeft;
    const y = target.offsetTop;

    if (skipAnimation) {
      this.bar.style.transitionDuration = '0s';
    } else {
      this.bar.style.transitionDuration = null;
    }

    this.bar.style.setProperty('--tractor-x', `${x}px`);
    this.bar.style.setProperty('--tractor-y', `${y}px`);
    this.bar.style.setProperty('--tractor-width', `${target.clientWidth}px`);
    this.bar.style.setProperty(
      '--tractor-height',
      `${target.clientHeight + 1}px`
    );
  }
}
